'use client';
import React from 'react';


interface Finding {
  ref: string;
  question: string;
  vessels: number;
  severity: string;
  lsd: number;
}

interface Props {
  findings: Finding[];
}

const SEVERITY_STYLE: Record<string, string> = {
  Critical: 'badge-critical',
  Severe: 'badge-severe',
  Moderate: 'badge-moderate',
  Minor: 'badge-minor',
  Normal: 'badge-normal',
};

export default function TopFindingsList({ findings }: Props) {
  return (
    <div className="space-y-2">
      {findings.map((f, i) => (
        <div
          key={`finding-${f.ref}`}
          className="flex items-start gap-3 p-3 rounded-lg transition-colors hover:bg-muted/40"
        >
          <span className="text-xs font-bold tabular-nums w-5 flex-shrink-0 text-muted mt-0.5">{i + 1}</span>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5 mb-0.5">
              <span className="font-mono text-xs font-semibold" style={{ color: 'hsl(var(--primary))' }}>{f.ref}</span>
              <span className={`badge ${SEVERITY_STYLE[f.severity] || 'badge-normal'} text-xs`}>{f.severity}</span>
              <span className={`lsd-score lsd-${f.lsd} text-xs ml-1`}>{f.lsd}</span>
            </div>
            <p className="text-xs leading-snug truncate" title={f.question}>{f.question}</p>
          </div>
          <div className="flex items-center gap-1 flex-shrink-0">
            <Ship size={11} className="text-muted" />
            <span className="text-xs font-bold tabular-nums">{f.vessels}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

function Ship({ size, className }: { size: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M2 21c.6.5 1.2 1 2.5 1C7 22 7 20 9.5 20c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
      <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76" />
      <path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6" />
      <path d="M12 10v4" />
      <path d="M12 7v.01" />
    </svg>
  );
}